import { SvgIcon } from '../../icons/SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
}

export const TagsGraphic: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`tags-graphic ${className || ''}`} height={132} width={132}>
			<circle cx='66' cy='66' r='66' fill='#F9F9F9' />
			<path
				d='M46.626 33.936L71.01 25.06l28.398 19.507 17.429 47.884a4 4 0 01-2.391 5.127l-54.502 19.837a4 4 0 01-5.127-2.391L37.388 67.141l9.238-33.205z'
				fill='#CAE0EC'
			/>
			<path d='M53.038 27h25.948L99 55.043V106a4 4 0 01-4 4H37a4 4 0 01-4-4V55.043L53.038 27z' fill='#00AAE8' />
			<path d='M35 55.684V106a2 2 0 002 2h58a2 2 0 002-2V55.684L77.956 29H54.067L35 55.684z' fill='#E8F3F9' />
			<rect x='50' y='66' width='32' height='2' rx='1' fill='#00AAE8' />
			<rect x='50' y='76' width='32' height='2' rx='1' fill='#00AAE8' />
			<rect x='50' y='86' width='32' height='2' rx='1' fill='#00AAE8' />
			<circle cx='66' cy='43' r='6' fill='#F2F2F2' stroke='#00AAE8' strokeWidth='2' />
			<mask id='a' maskUnits='userSpaceOnUse' x='46' y='6' width='49' height='41'>
				<path d='M62 40s-1 1-1 4 17 2 17 2l17-32-23-8-20 5-6 12 2 11 5-7 9 13z' fill='#fff' />
			</mask>
			<g mask='url(#a)'>
				<circle cx='66' cy='27' r='16' stroke='#00AAE8' strokeWidth='2' fill='none' />
			</g>
		</SvgIcon>
	);
};
